import { Controller } from "@hotwired/stimulus"
import parentDatasetSearch from "../utils/parent_dataset_search"

export default class extends Controller {
  static values = {
    destinationUrl: String,
    target: String,
  }

  connect() {
    // Defer setting data-clickable-row=true until after DOM updates and event handlers are attached
    // This prevents race conditions where tests click before action bindings are ready
    requestAnimationFrame(() => {
      this.element.dataset.clickableRow = true
    })
  }

  navigateToDestinationUrl(event) {
    if(this.shouldPreventNavigation(event.target)) return

    if (this.hasTargetValue) {
      window.open(this.destinationUrlValue, this.targetValue)
    } else {
      Turbo.visit(this.destinationUrlValue)
    }
  }

  shouldPreventNavigation(element) {
    return parentDatasetSearch(element, "preventNavigation")
  }
}
